import { useEffect, useState } from 'react';
import { getAgentMemory } from '../lib/api/agents';
import { agentMemory, agentMemoryStats } from '../mocks/agentDetail';

/**
 * Memory tab data. Fetch-first (GET /api/agents/:id/memory over memoryDao is
 * registered this batch), mock fallback on error — and the fallback is no
 * longer silent: `mode` returns 'live'|'sample' so the tab renders an honest
 * DataMode badge (go-live-readiness §1: fallbacks must be labeled).
 */
function useAgentMemory(agentId) {
  const [facts, setFacts] = useState([]);
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState('sample');

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    getAgentMemory(agentId)
      .then((data) => {
        if (cancelled) return;
        setFacts(data.facts);
        setStats(data.stats);
        setMode('live');
      })
      .catch(() => {
        // No backend yet — mocks are the interim API contract.
        if (cancelled) return;
        setFacts(agentMemory(agentId));
        setStats(agentMemoryStats(agentId));
        setMode('sample');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [agentId]);

  return { facts, setFacts, stats, isLoading, mode };
}

export default useAgentMemory;
